export const LOAD_SURVEYS = 'LOAD_SURVEYS';
export const SELECTED_SURVEY = 'SELECTED_SURVEY';
export const LOADING_START = 'LOADING_START';
export const LOADING_DONE = 'LOADING_DONE';

